<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" type="warning"  @click="handEditorView(method)" :disabled="!hasPermission('unmsets:cecUnmSets:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="24">
          <el-form-item label="封面" prop="pic"
                :rules="[
                  {required: true, message:'封面不能为空', trigger:'blur'}
                 ]">
                 <CropperView :imgSrc="inputForm.pic" :disabled="method === 'view'"  :actionButtonFlag="true" :objectFit="'cover'" :listIndex="1" @updateChange="changeImage($event,inputForm)"></CropperView>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目数量" prop="num"
                :rules="[
                 ]">
              <el-input v-model="inputForm.num" placeholder="请填写项目数量"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="套餐价格" prop="targetPrice"
                :rules="[
                 ]">
              <el-input v-model="inputForm.targetPrice" placeholder="请填写套餐价格"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="排序" prop="sort"
                :rules="[
                  {required: true, message:'排序不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="类型" prop="type"
                :rules="[
                  {required: true, message:'类型不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.type" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in $dictUtils.getDictList('sets_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
  import CropperView from '@/components/upload/ImageUploadCropper.vue'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          num: '',
          targetPrice: '',
          sort: '',
          type: '',
          pic: '',
          coverImage: {
            filePath: ''
          }
        }
      }
    },
    components: {
      CropperView
    },
    methods: {
      //  upload image 上传图片
      changeImage (e, item) {
        if (e) {
          item.pic = typeof e === 'string' ? e : e.filePath
          item.coverImage = {
            category: 'setsCover',
            filePath: typeof e === 'string' ? e : e.filePath
          }
          // this.saveData(item)
        }
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建套餐表`
        } else if (method === 'edit') {
          this.title = '修改套餐表'
        } else if (method === 'view') {
          this.title = '查看套餐表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmSetsService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              if (data.coverImage) {
                this.inputForm.pic = data.coverImage.filePath
              }
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmSetsService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
</style>
  
